<template>
    <div id="esqueci-screen">

        <LeftPanel />

        <div class="right-panel d-flex align-items-center justify-content-center">
          <b-alert :show="enviado" fade variant="success" class="text-center">
              <!-- <h4>Solicitação enviada</h4> -->
              <p class="mb-0"> Validação de {{ validacao }} efetuada com sucesso! .</p>
            </b-alert>
        </div>
    </div>
</template>

<script>
import LeftPanel from '../views/Login/LeftPanel.vue'
import API from '../services/api'

export default {
  props: ['tipo_login'],
  components: {
      LeftPanel,
  },
  data() {
    return {
      enviado:false,
      validacao:''
      
    }
  },
  methods: {
   
  },
  created() {
    let route_validacao =  this.$route.meta.cd_tipo_validacao == 1 ? '/user/validate/email/' + this.$route.params.id : '/user/validate/sms/' + this.$route.params.id;
    this.validacao = this.$route.meta.cd_tipo_validacao == 1 ? 'E-mail': 'SMS';
    API.get(route_validacao).then(() =>{
      this.enviado = true
    })
    // this.redefinida = true;
  }
}
</script>

<style>
::placeholder {
  color: #BBB;
}
.logo {
  cursor: pointer;
  margin-bottom: 30px;
  height: 70px;
}
#esqueci-screen {
  position: absolute;
  width: 100%;
  height: 100%;
  /* background-color: var(--main-bg-cinza); */
}
#esqueci-screen .right-panel {
  position: absolute;
  right: 0%;
  width: 50%;
  height: 100%;
}
#loading-enviar {
  vertical-align: 0;
  margin-left: -21px;
}
.card{
  border: 1px solid #597EB5;
border-radius: 5px;
padding: 38px 38px 38px 37px !important;
}
.card-body h4{
  font: normal normal bold 25px/32px 'Kanit', sans-serif;
letter-spacing: 0px;
color: #597EB5;
text-align: center;
margin-bottom: 32px;
}
.card-text{width: inherit;
text-align: center;
font: normal normal normal 15px/20px 'Kanit', sans-serif;
letter-spacing: 0px;
color: #597EB5;
margin-bottom: 10px;}
.card-body input:active, .card-body input:focus{background: #F1F1F1 0% 0% no-repeat padding-box;}
.card-body input{
  border: 1px solid #FFFFFF;
  border-radius: 5px;
  text-align: left;
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  width: 303px !important;
  height: 35px;
  margin-bottom: 13px !important;
  background: #F1F1F1 0% 0% no-repeat padding-box;
}
.card-body button.btn-primary{background: #597EB5 0% 0% no-repeat padding-box !important;
border-radius: 5px !important;
border: none !important;
text-align: center;
font: normal normal bold 15px/20px 'Kanit', sans-serif;
letter-spacing: 0px;
color: #FFFFFF;
padding: 9px 0;
width: 303px !important;}

.alert{
  max-height: 49px;
  padding: 15px 17px;
  border-radius: 5px;
  font: normal normal bold 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  text-align:start !important;
}
.alert.alert-success{background: #CBF8D8 0% 0% no-repeat padding-box;color: #27703C;}
.alert.alert-warning {background: #F8F5CB 0% 0% no-repeat padding-box;color: #706927;}
.alert.alert-danger{background: #F8CBCB 0% 0% no-repeat padding-box;color: #702727;}

.card-redefina-senha .alert{
  max-height: none;
  max-width: 303px;
}
.card-redefina-senha .alert ul{margin-bottom: 0;} 
.btn-success{
    background-color: #27703C;
    border-color: #27703C;
    font: normal normal bold 15px/20px 'Kanit', sans-serif !important;
    letter-spacing: 0px;}
</style>
